import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarOutlineIcon = (props: IconProps) => (
  <Icon height="16px" width="16px" viewBox="0 0 16 16" {...props}>
    <path
      strokeWidth="1.5"
      d="m10.3589 5.06584 3.6079.51908c.3027.04944.555.24719.6559.54381.1009.2719.0253.59324-.2018.79098L11.797 9.4657l.6307 3.6089c.0505.2966-.0756.5932-.3279.7662-.2523.1978-.5803.1978-.8579.0742l-3.22937-1.7056L4.7579 13.915c-.2523.1236-.60552.1236-.83259-.0742-.25229-.173-.37844-.4696-.32798-.7662l.60551-3.6089-2.62389-2.54599c-.22707-.19774-.30276-.51908-.20184-.79098.10092-.29662.35322-.49437.65597-.54381l3.63309-.51908 1.6147-3.28754c.12615-.2719.40368-.44493.73166-.44493.30276 0 .58029.17303.70644.44493l1.63993 3.28754Z"
    />
  </Icon>
);

export default memo(StarOutlineIcon);
